<script>
  import { onMount, onDestroy } from "svelte";

  export let added;
  export let removed;

  let visible = false;

  onMount(() => setTimeout(() => (visible = true), 100));

  // onDestroy(() => setTimeout(() => alert("Destroyed"), 1000));
</script>

<style>
  div:not(.visible) {
    opacity: 0;
    transform: scale(0.2);
  }

  div {
    --xOffset: 500px;
    --scale: 0.7;
    position: absolute;
    /* background: rgba(0, 0, 0, 0.5); */
    border-radius: 5px;
    height: 100%;
    width: 40%;
    /* Transition */
    transition: transform 0.5s ease-out, opacity 0.5s ease-out;
  }

  div:not(.added) {
    transform: translateX(var(--xOffset)) scale(var(--scale));
    opacity: 0;
  }

  div.removed {
    transform: translateX(calc(-1 * var(--xOffset))) scale(var(--scale));
    opacity: 0;
  }

  @media (max-width: 500px) {
    div {
      width: 95%;
    }
  }
</style>

<div class:visible class:removed class:added>
  <slot />
</div>
